import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { storeToolkit } from './app/store';
import App from './App';
import { StyledToastContainer } from './components/common/Toasts/ToastsStyled';
import { chooseTheme, GlobalStyles } from './styles/GlobalStyles';
import 'react-toastify/dist/ReactToastify.min.css';
import './index.css';
import './i18n';

import { chains } from './config/chains';

import { WagmiProvider } from 'wagmi';

import { createWeb3Modal } from '@web3modal/wagmi/react';
import { defaultWagmiConfig } from '@web3modal/wagmi/react/config';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

const projectId = '2ecc3262ca51da051900c4cbd03890f7';

const metadata = {
  name: `Web3Modal`,
  description: `Web3Modal Example`,
  url: `https://web3modal.com`,
  icons: [`https://avatars.githubusercontent.com/u/37784886`]
};

const config = defaultWagmiConfig({
  chains,
  projectId,
  metadata
});

createWeb3Modal({
  metadata,
  wagmiConfig: config,
  projectId,
  enableAnalytics: true
});

const container: any = document.getElementById('root');
const root = createRoot(container);

root.render(
  <WagmiProvider config={config}>
    <QueryClientProvider client={queryClient}>
      <Provider store={storeToolkit}>
        <ThemeProvider theme={chooseTheme}>
          <GlobalStyles />
          <StyledToastContainer />
          <App />
        </ThemeProvider>
      </Provider>
    </QueryClientProvider>
  </WagmiProvider>
);
